import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';
import { AttendeeSearchResult } from '../types/attendee-search-result';

interface AttendeeSearchResultParams {
  eventId: number;
  breakoutId?: number;
  status?: string | null;
  searchKey: string;
  config?: {
    enabled: boolean;
  };
}

export const getAttendeeSearchResult = ({ eventId, breakoutId, searchKey, status }: AttendeeSearchResultParams): Promise<AttendeeSearchResult[]> => {
  return axios.get(`/${eventId}/onsite/search`, {
    params: {
      searchKey,
      breakoutId,
      status,
    },
  });
};

type QueryFnType = typeof getAttendeeSearchResult;

type UseOptions = {
  searchKey: string;
  eventId: number;
  breakoutId?: number;
  status?: string | null;
  config?: QueryConfig<QueryFnType>;
};

export const useAttendeeSearchResult = ({ eventId,breakoutId, status, searchKey, config }: UseOptions) => {
  let keyString = `${eventId}_${searchKey}`;
  if (breakoutId !== undefined) {
    keyString = `${eventId}_${breakoutId}_${searchKey}`;
  }
  if (status !== null && status !== undefined) {
    keyString = breakoutId !== undefined ? `${eventId}_${breakoutId}_${status}_${searchKey}` : `${eventId}_${status}_${searchKey}`;
  }

  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['attendee_search_result', keyString],
    queryFn: () => getAttendeeSearchResult({ eventId, breakoutId, searchKey, status }),
    ...config,
  });
};
